<template>
  <div class="creditForm">
    <img class="creditForm__brand" height="24" src="/static/img/academy/credit_brand1.png" alt="card">
    <form-credit-card
      label="カード番号"
      name="ccNumber"
      placeholder="例）1234 5678 9123 4567"
      :value="input.ccNumber"
      @input="changeInput($event, 'ccNumber')"
      :validation="{ rules: { required: true, credit_card: true } }"
    ></form-credit-card>

    <form-credit-expire
      name
      label="カード有効期限"
      month-name="cc_expiration_m"
      year-name="cc_expiration_y"
      :value="input.ccExpiration"
      @input="changeInput($event, 'ccExpiration')"
      :validation="{ rules: { required: true } }"
    ></form-credit-expire>

    <form-select
      name="number_payments"
      label="支払い回数"
      :value="input.numberPayments"
      @input="changeInput($event, 'numberPayments')"
      :options="option.numberPayments"
      :validation="{ rules: { required: true,} }"
    ></form-select>

    <div class="creditForm__notice">
      <p>※分割払いは、JCB／AMEXのみご利用いただけます。その他ブランドのクレジットカードをご利用のお客様は、一括払いかコンビニ決済でお支払いください。</p>
    </div>

    <div class="securityCode">
      <form-input
        label="セキュリティコード"
        name="security_code"
        type="tel"
        input-width="72px"
        maxlength="4"
        :value="input.securityCode"
        @input="changeInput($event, 'securityCode')"
        :validation="{ rules: { required: true, numeric: true, max: 4 } }"
      ></form-input>
      <div class="securityCode__question" @click="openAboutSecurityCode">
        <img width="20" height="20" src="/static/img/icons/question.svg">
      </div>
      <div class="securityCode__about media" :data-visible="showAboutSecurityCode">
        <div class="media__image">
          <img src="/static/img/security-code.png" width="48" height="30">
        </div>
        <div class="media__content">
          <p>セキュリティコードはカード裏面に記載されている３桁または、表面に記載されている４桁の番号です。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreditCardFormSplit',
  props: {
    input: Object,
    option: Object,
  },
  data() {
    return {
      // セキュリティコードの説明の表示
      showAboutSecurityCode: false,
    }
  },
  watch: {
    input: {
      handler() {
        // changeInput で errors 渡すとずれるのでこのタイミングで errors だけ渡す
        // 原因：子→親→子 でデータの受け渡しがあるから。changeInput で親に渡す時点ではエラーなくても、子に戻してからエラーになる。
        this.$emit('error', this.errors.all().length)
      },
      deep: true
    }
  },
  methods: {
    // セキュリティコードの説明を表示
    openAboutSecurityCode() {
      this.showAboutSecurityCode = !this.showAboutSecurityCode
      if (this.showAboutSecurityCode) {
        setTimeout(this.openAboutSecurityCode, 5000)
      }
    },
    // 親に変更を送る
    changeInput($event, target) {
      this.$emit('change', { target: target, value: $event })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/commons/commonVariables.scss';
.creditForm {
  &__brand {
    margin: 0 0 21px;
  }
  &__notice {
    font-size: 12px;
    margin: -12px 0 24px;
    color: $academy_purple;
    line-height: 1.2;
  }
}
.securityCode {
  position: relative;
  &__question {
    position: absolute;
    left: 88px;
    top: 30px;
    cursor: pointer;
  }
  &__about {
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 8px;
    z-index: 2;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
    border-radius: 4px;
    left: 120px;
    top: 0;
    align-items: center;
    pointer-events: none;
    opacity: 0;
    transition: opacity 250ms ease-in-out;
    &[data-visible='true'] {
      opacity: 1;
      pointer-events: auto;
    }
    .media__content p {
      font-size: 10px;
      line-height: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Academy/partials/CreditCardFormSplit.vue